import { useNavigate } from "react-router-dom"
import { Box, HStack, Separator, Spacer, Stack, VStack } from "@chakra-ui/react"
import { Text } from "@/components"
import { EsoClient } from "@/types"

interface Props {
  client: EsoClient
}

export const ClientListItem = ({ client }: Props) => {
  const navigate = useNavigate()

  return (
    <VStack
      cursor="pointer"
      bg="white"
      borderRadius={10}
      boxShadow="sm"
      _hover={{ boxShadow: "lg" }}
      w="100%"
      align="stretch"
      onClick={() => navigate(`/clients/${client.id}`)}
    >
      <Stack p={5} w="100%" gap={3}>
        <HStack w="100%">
          <Text fontSize={{ base: "lg", md: "2xl" }} fontWeight="bold">
            {client.firstName} {client.lastName}
          </Text>
          <Spacer />
          <Text fontSize="sm">
            Created: {client.createdDate}
          </Text>
        </HStack>
        <Text fontSize="md">{client.email}</Text>
        <Text fontSize="md">{client.phoneNumber}</Text>
        <Separator />
        {
          client.deals && client.deals.length > 0 && (
            <Text fontSize="sm">
              Deals:
            </Text>
          )
        }
        <HStack flexWrap="wrap">
          {client.deals && client.deals.length > 0 ? (
            client.deals.map((deal) => (
              <Box key={deal.id} px={3} py={1} bg="brand.25" borderRadius="md" fontSize="sm">
                <Text fontSize="md" color="white" fontWeight="bold">
                  {deal.company.name}
                </Text>
                <Text fontSize="xs" color="white">
                  Stage: {deal.stage}
                </Text>
              </Box>
            ))
          ) : (
            <Text fontSize="sm">No deals available</Text>
          )}
        </HStack>
      </Stack>
    </VStack>
  )
}
